export default "__VITE_ASSET__25uotz$s__"